const usAreaCodes = {
  MS: [228, 601, 662, 769],
  MP: [670],
  OK: [405, 539, 580, 918],
  DE: [302],
  MN: [218, 320, 507, 612, 651, 763, 952],
  IL: [217, 224, 309, 312, 331, 618, 630, 708, 773, 779, 815, 847, 872],
  AR: [479, 501, 870],
  NM: [505, 575],
  IN: [219, 260, 317, 574, 765, 812],
  MD: [240, 301, 410, 443, 667],
  LA: [225, 318, 337, 504, 985],
  ID: [208],
  WY: [307],
  TN: [423, 615, 731, 865, 901, 931],
  AZ: [480, 520, 602, 623, 928],
  IA: [319, 515, 563, 641, 712],
  MI: [231, 248, 269, 313, 517, 586, 616, 734, 810, 906, 947, 989],
  KS: [316, 620, 785, 913],
  UT: [385, 435, 801],
  AS: [684],
  OR: [458, 503, 541, 971],
  CT: [203, 475, 860],
  MT: [406],
  CA: [
    209, 213, 310, 323, 408, 415, 424, 442, 510, 530, 559, 562, 619, 626, 650, 657, 661,
    669, 707, 714, 747, 760, 805, 818, 831, 858, 909, 916, 925, 949, 951
  ],
  MA: [339, 351, 413, 508, 617, 774, 781, 857, 978],
  PR: [787, 939],
  SC: [803, 843, 864],
  NH: [603],
  WI: [262, 414, 534, 608, 715, 920],
  VT: [802],
  GA: [229, 404, 470, 478, 678, 706, 762, 770, 912],
  ND: [701],
  PA: [215, 267, 272, 412, 484, 570, 610, 717, 724, 814, 878],
  WV: [304, 681],
  FL: [
    239, 305, 321, 352, 386, 407, 561, 727, 754, 772, 786, 813, 850, 863, 904, 941, 954
  ],
  HI: [808],
  KY: [270, 502, 606, 859],
  AK: [907],
  NE: [308, 402, 531],
  MO: [314, 417, 573, 636, 660, 816],
  OH: [216, 234, 330, 419, 440, 513, 567, 614, 740, 937],
  AL: [205, 251, 256, 334, 938],
  RI: [401],
  undefined: [202],
  VI: [340],
  SD: [605],
  CO: [303, 719, 720, 970],
  NJ: [201, 551, 609, 732, 848, 856, 862, 908, 973],
  VA: [276, 434, 540, 571, 703, 757, 804],
  GU: [671],
  WA: [206, 253, 360, 425, 509],
  NC: [252, 336, 704, 828, 910, 919, 980, 984],
  NY: [212, 315, 347, 516, 518, 585, 607, 631, 646, 716, 718, 845, 914, 917, 929],
  TX: [
    210, 214, 254, 281, 325, 346, 361, 409, 430, 432, 469, 512, 682, 713, 737, 806, 817,
    830, 832, 903, 915, 936, 940, 956, 972, 979
  ],
  NV: [702, 725, 775],
  ME: [207]
}

export default usAreaCodes
